import { LicenseGroup, useGetAllLicenseGroupsQuery } from '../../api/models'

export const useGetAllLicGroups = (): { lGroups?: LicenseGroup[]; lGroupErr?: string; lGroupLoading?: boolean } => {
  const { data, error, loading } = useGetAllLicenseGroupsQuery()

  //console.log(`data`, data?.getAllLicenseGroups)

  return { lGroups: data?.getAllLicenseGroups as LicenseGroup[], lGroupErr: error?.message, lGroupLoading: loading }
}
